import { render, staticRenderFns } from "./Deeplink.vue?vue&type=template&id=4843c282"
import script from "./Deeplink.vue?vue&type=script&lang=js"
export * from "./Deeplink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports